declare module '#app' {
  interface NuxtApp {
    $easyApi: typeof $fetch
  }
}

export default defineNuxtPlugin(() => {
  const { app } = useRuntimeConfig()
  const easyApi = $fetch.create({
    baseURL: `${app.baseURL}/api/easyApi`,
  })
  return {
    provide: {
      easyApi,
    },
  }
})
